document.addEventListener('DOMContentLoaded', function () {

  // ── Elements ─────────────────────────────────────────────────────────────
  var form            = document.getElementById('add-to-cart-form');
  var addToCartBtn    = document.getElementById('purchase');
  var isGiftCheckbox  = document.getElementById('isGift');
  var modal           = document.getElementById('giftMessageModal');
  var closeModal      = document.querySelector('.close');
  var messageTextarea = document.getElementById('custom-message');
  var messagePreview  = document.getElementById('message-preview-text');
  var giftForm        = document.getElementById('giftMessageForm');

  if (!form) return;

  // ── Button active state ───────────────────────────────────────────────────
  var formatRadios = document.querySelectorAll('.gift-format-btn input[type="radio"]');
  var formatLabels = document.querySelectorAll('.gift-format-btn');

  function syncGiftFormatButtons() {
    formatLabels.forEach(function (label) {
      label.classList.remove('active');
    });

    var checkedRadio = document.querySelector('.gift-format-btn input[type="radio"]:checked');

    if (checkedRadio) {
      var checkedLabel = checkedRadio.closest('.gift-format-btn');
      if (checkedLabel) checkedLabel.classList.add('active');
    }
  }

  formatLabels.forEach(function (label) {
    label.addEventListener('click', function () {
      var radio = label.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      syncGiftFormatButtons();
    });
  });

  formatRadios.forEach(function (radio) {
    radio.addEventListener('change', syncGiftFormatButtons);
  });

  syncGiftFormatButtons();

  window.addEventListener('pageshow', function () {
    syncGiftFormatButtons();
  });

  // ── Modal ─────────────────────────────────────────────────────────────────
  function toggleModal(show) {
    if (modal) modal.style.display = show ? 'block' : 'none';
  }

  if (messagePreview) messagePreview.textContent = 'Start typing your message...';

  if (isGiftCheckbox) {
    isGiftCheckbox.addEventListener('change', function () {
      toggleModal(this.checked);
    });
  }

  if (closeModal) {
    closeModal.addEventListener('click', function () {
      toggleModal(false);
      if (isGiftCheckbox) isGiftCheckbox.checked = false;
    });
  }

  if (messageTextarea) {
    messageTextarea.addEventListener('input', function () {
      if (messagePreview) messagePreview.textContent = this.value || 'Start typing your message...';
    });
  }

  // ── Helper: set a line item property hidden input ─────────────────────────
  function setProp(name, value) {
    var input = form.querySelector('[name="properties[' + name + ']"]');
    if (input) input.value = value;
  }

  // ── Helper: write gift data to cart note (becomes gift_card.order.note) ───
  // Format must match exactly what the Shopify gift card email template parses.
  // Template splits on: 'Gift Message To:' ... ' Message:' ... ' From:'
  function saveGiftToCartNote(to, from, message) {
    var note = 'Gift Message To: ' + to + ' Message: ' + message + ' From: ' + from;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: note })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart note update failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        console.log('Cart note updated with gift data.');
      })
      .catch(function (err) {
        console.error('Failed to update cart note:', err);
      });
  }

  // ── Gift message save ─────────────────────────────────────────────────────
  if (giftForm) {
    giftForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var to      = document.getElementById('to')?.value.trim();
      var from    = document.getElementById('from')?.value.trim();
      var message = messageTextarea?.value.trim();

      if (!to || !from || !message) {
        alert('Please fill in all gift message fields.');
        return;
      }

      // 1. Set line item properties (visible in Shopify admin order, Klaviyo, etc.)
      setProp('Is Gift',      'on');
      setProp('Gift To',      to);
      setProp('Gift From',    from);
      setProp('Gift Message', message);

      // 2. Write to cart note so it becomes gift_card.order.note in the
      //    Shopify native gift card notification email
      saveGiftToCartNote(to, from, message).then(function () {
        toggleModal(false);
      });
    });
  }

  // ── Add to cart intercept for digital gift vouchers ───────────────────────
  var isAddingDigitalVoucher = false;

  function getSelectedGiftFormat() {
    return document.querySelector('input[name="gift-format"]:checked');
  }

  function isDigitalGiftSelected() {
    var selectedFormat = getSelectedGiftFormat();
    return selectedFormat && selectedFormat.value === 'digital';
  }

  function getDigitalVariantId() {
    var digitalVariantId = window.voucherVariantId;

    if (!digitalVariantId) {
      console.error('No voucherVariantId found — check the product metafield.');
      return null;
    }

    if (String(digitalVariantId).includes('/')) {
      digitalVariantId = String(digitalVariantId).split('/').pop();
    }

    digitalVariantId = parseInt(digitalVariantId, 10);

    if (!digitalVariantId) {
      console.error('Invalid voucherVariantId — Shopify needs a variant ID.');
      return null;
    }

    return digitalVariantId;
  }

  function getQuantity() {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;
    return quantity;
  }

  // Collects line item properties AND adds Format: Digital
  function getGiftProperties() {
    var properties = {};

    ['Is Gift', 'Gift To', 'Gift From', 'Gift Message'].forEach(function (key) {
      var el = form.querySelector('[name="properties[' + key + ']"]');
      if (el && el.value) properties[key] = el.value;
    });

    properties['Format'] = 'Digital';

    return properties;
  }

  function addDigitalVoucherToCart(event) {
    if (!isDigitalGiftSelected()) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (isAddingDigitalVoucher) return;

    var digitalVariantId = getDigitalVariantId();
    if (!digitalVariantId) return;

    isAddingDigitalVoucher = true;

    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('loading');
    }

    // Collect gift data for the cart note before adding to cart,
    // in case the modal was skipped (non-gift purchase)
    var to      = document.getElementById('to')?.value.trim()      || '';
    var from    = document.getElementById('from')?.value.trim()     || '';
    var message = messageTextarea?.value.trim()                      || '';

    // Build the cart note update promise — only write if gift data exists
    var notePromise = (to && from && message)
      ? saveGiftToCartNote(to, from, message)
      : Promise.resolve();

    notePromise.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: digitalVariantId,
          quantity: getQuantity(),
          properties: getGiftProperties()
        })
      });
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (item) {
        console.log('Digital voucher added:', item);

        var cartLinkInput = document.getElementById('cart-link');
        var cartUrl = cartLinkInput && cartLinkInput.value ? cartLinkInput.value : '/cart';

        window.location.href = cartUrl;
      })
      .catch(function (err) {
        console.error('Failed to add digital voucher:', err);

        isAddingDigitalVoucher = false;

        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('loading');
        }
      });
  }

  form.addEventListener('submit', addDigitalVoucherToCart, true);

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (event) {
      if (isDigitalGiftSelected()) {
        addDigitalVoucherToCart(event);
      }
    }, true);
  }

});